import classNames from "classnames"
import s from '../../index.module.css';
import classes from './index.module.css';
import { createContext, Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectProfile } from "@store/profile.reducer";
import setSettingsFromServer from "@/helpers/setSettingsFromServer";
import { InputSelect } from "@UI/InputNew";
import { useInputNew } from "@UI/InputNew/useInputNew";
import { actionsConfig, actionOptions } from "./actionsConfig";
import { dynamicImport } from "@/helpers/new/dynamicImport"; 
import Preloader from "@UI/Preloader";
import { useAddAlert } from "@/hooks/useAddAlert";
import { fetchTimetableData } from "@store/timetable/fetchTimetableData";
import { closeAllModal } from "@store/modalsSlise";
import { timetableBeta, usersAPI } from "@/api";
import useLoad from "@/hooks/useLoad";

export const ModalEditLessonOrMeetingContext = createContext(null);

const EditLessonOrMeeting = ({data}) => {
    const addAlert = useAddAlert()
    const dispatch = useDispatch()
    const profile = useSelector(selectProfile);
    const [settings, setSettings] = useState(null)

    useEffect(() => {
        setSettingsFromServer(setSettings)
    }, [])

    const [shouldUpdateFollowingLessons, setShouldUpdateFollowingLessons] = useState(false);
    const toggleShouldUpdateFollowingLessons = () => setShouldUpdateFollowingLessons(prev => !prev)

    const [LazyComponent, setLazyComponent] = useState(null);
    const [type, setType] = useState(null);

    const onChange = async (value) => {
        setType(value)

        if (!value) {
            setLazyComponent(null);
            return;
        }

        const action = actionsConfig[value];
        if (!action) return;

        try {
            const Component = dynamicImport(action.component);
            setLazyComponent(Component);
        }
        catch (error) {
            console.error("Failed to load component:", error);
            setLazyComponent(null);
        }
    };

    const availableActionOptions = actionOptions.filter((option) => {
        const config = actionsConfig[option.value];
        return config.isAvailable({report: data.report, role: profile.role, settings});
    });
    
    const [bindAction] = useInputNew({
        name: 'action',
        onChange,
        placeholder: 'Выберите изменения из списка',
        options: availableActionOptions,
        value: type,
    });

    
    const [state, setState] = useState({});
    const [initialState, setInitialState] = useState({});

    const setFieldInState = ({field, value}) => {
        setState((prevState) => (
            {
                ...prevState,
                [field]: value
            }
        ))
    }
    const toggleAttendees = (value, type = 'id') => {
        setState((prev) => {
            let attendees;
            if(type == 'id'){
                attendees = prev.attendees.includes(value) ? prev.attendees.filter(iterId => iterId !== value) : [...prev.attendees, value];
            }
            if(type == 'mass'){
                attendees = value;
            }
            return(
                {
                    ...prev,
                    ...(attendees && {attendees})
                }
            )
        })
    }
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        timetableBeta.getReport({id:data.report.id})
            .then(({data})=>{
                if(data.status === 'success'){
                    setState(data?.data)
                    setInitialState(data?.data)
                }
            })
            .finally(()=> setLoading(false))
    }, [data.report.id])

    const successfullyChanged = ({text = 'Занятие изменено'} = {}) => {
        addAlert({title: 'Успешно', text})
        dispatch(fetchTimetableData())
        dispatch(closeAllModal())
    }
    const failedToChange = () => {
        addAlert({title: 'Ошибка', text: 'При изменении данных произошла ошибка', type: 'error'})
    }

    const { 
        state: courseSeminariansList, 
        loading: loadingCourseSeminariansList,
        getState: getCourseSeminariansList,
    } = useLoad({
        api: usersAPI.searchUsersForSelect,
        params: {
            employeeDirection: state.direction_id,
            status: 10,
            role: 'seminarian',
            pageSize: false,
        },
        key: "data",
        initState: [],
        last: false,
    });
    useEffect(()=>{
        if(!!state.direction_id){
            getCourseSeminariansList()
        }
    }, [state.direction_id])

    return (
        <ModalEditLessonOrMeetingContext.Provider 
            value={
                {
                    settings,
                    profile,
                    type,
                    shouldUpdateFollowingLessons,
                    toggleShouldUpdateFollowingLessons,
                    state,
                    setFieldInState,
                    successfullyChanged,
                    failedToChange,
                    courseSeminariansList,
                    loadingCourseSeminariansList,
                    toggleAttendees,
                    initialState
                }
            }>
            <div className={classNames(s.modalContainer, classes.modalContainer)}>
                <div className={s.modalHeader}>
                <div className={s.modalTitleContainer}>
                    <span className={s.modalHeaderBigTitle}>
                        Внести изменения в расписание
                    </span>
                </div>
                </div>
                <div className={classNames(s.contentWrapper, classes.contentWrapper)}>
                    {
                        (settings === null || loading) ? <Preloader /> : (
                            <>
                                <InputSelect
                                        classSelectItem={classes.classSelectItem}
                                        classNameInputBoxSelect={classes.classNameInputBoxSelect}
                                        className={classes.backgroundPrimary}
                                        classSelectItemSelected={classes.classSelectItemSelected}
                                        newDesign
                                        {...bindAction} 
                                />
                                {LazyComponent && (
                                    <>
                                        <Suspense fallback={<Preloader />}>
                                            <LazyComponent />
                                        </Suspense>
                                    </>
                                )}
                            </>
                        )
                    }
                </div>
            </div>
        </ModalEditLessonOrMeetingContext.Provider>
    )
}
export default EditLessonOrMeeting;